import { useMutation, useQuery } from "@tanstack/react-query"
import { apiFetchFormData, apiFetchProtected } from "../utils/api"
import { MedicalDocumentsGetResponse } from "../types/types"

export const useDocumentsMutation = (patientId: string) => {
  return useMutation({
    mutationFn: (fileUpload: FormData) =>
      apiFetchFormData(`/patients/${patientId}/medical_documents`, {
        method: "POST",
        body: fileUpload
      }),
    onError: (error) => {
      console.error("Error:", error)
    }
  })
}

export const useDocumentsQuery = (patientId: string) =>
  useQuery({
    queryKey: ["medical_documents"],
    queryFn: () => fetchDocuments(patientId)
  })

const fetchDocuments = async (
  patientId: string
): Promise<MedicalDocumentsGetResponse> =>
  await apiFetchProtected<MedicalDocumentsGetResponse>(
    `/patients/${patientId}/medical_documents`,
    {}
  )
